import * as $dynamic from "../../gleam_stdlib/gleam/dynamic.mjs";
import { DecodeError } from "../../gleam_stdlib/gleam/dynamic.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import { Ok, makeError } from "../gleam.mjs";
import { emit, prevent_default, stop_propagation } from "../lustre.ffi.mjs";
import * as $attribute from "../lustre/attribute.mjs";
import * as $effect from "../lustre/effect.mjs";

export { emit, prevent_default, stop_propagation };

export function on(name, handler) {
  return $attribute.on(name, handler);
}

export function on_click(msg) {
  return on("click", (_) => { return new Some(msg); });
}

export function on_mouse_down(msg) {
  return on("mousedown", (_) => { return new Some(msg); });
}

export function on_mouse_up(msg) {
  return on("mouseup", (_) => { return new Some(msg); });
}

export function on_mouse_enter(msg) {
  return on("mouseenter", (_) => { return new Some(msg); });
}

export function on_mouse_leave(msg) {
  return on("mouseleave", (_) => { return new Some(msg); });
}

export function on_mouse_over(msg) {
  return on("mouseover", (_) => { return new Some(msg); });
}

export function on_mouse_out(msg) {
  return on("mouseout", (_) => { return new Some(msg); });
}

export function on_keypress(msg) {
  return on(
    "keypress",
    (event) => {
      let $ = $dynamic.field("key", $dynamic.string)(event);
      if ($.isOk()) {
        let key = $[0];
        return new Some(msg(key));
      } else if (!$.isOk()) {
        return new None();
      } else {
        throw makeError(
          "case_no_match",
          "lustre/event",
          80,
          "",
          "No case clause matched",
          { values: [$] }
        )
      }
    },
  );
}

export function on_keydown(msg) {
  return on(
    "keydown",
    (event) => {
      let $ = $dynamic.field("key", $dynamic.string)(event);
      if ($.isOk()) {
        let key = $[0];
        return new Some(msg(key));
      } else if (!$.isOk()) {
        return new None();
      } else {
        throw makeError(
          "case_no_match",
          "lustre/event",
          92,
          "",
          "No case clause matched",
          { values: [$] }
        )
      }
    },
  );
}

export function on_keyup(msg) {
  return on(
    "keyup",
    (event) => {
      let $ = $dynamic.field("key", $dynamic.string)(event);
      if ($.isOk()) {
        let key = $[0];
        return new Some(msg(key));
      } else if (!$.isOk()) {
        return new None();
      } else {
        throw makeError(
          "case_no_match",
          "lustre/event",
          104,
          "",
          "No case clause matched",
          { values: [$] }
        )
      }
    },
  );
}

export function on_submit(msg) {
  return on("submit", (_) => { return new Some(msg); });
}

export function on_focus(msg) {
  return on("focus", (_) => { return new Some(msg); });
}

export function on_blur(msg) {
  return on("blur", (_) => { return new Some(msg); });
}

export function value(event) {
  let _pipe = event;
  return $dynamic.field("target", $dynamic.field("value", $dynamic.string))(
    _pipe,
  );
}

export function on_input(msg) {
  return on(
    "input",
    (event) => {
      let $ = value(event);
      if ($.isOk()) {
        let val = $[0];
        return new Some(msg(val));
      } else if (!$.isOk()) {
        return new None();
      } else {
        throw makeError(
          "case_no_match",
          "lustre/event",
          116,
          "",
          "No case clause matched",
          { values: [$] }
        )
      }
    },
  );
}

export function checked(event) {
  let _pipe = event;
  return $dynamic.field("target", $dynamic.field("checked", $dynamic.bool))(
    _pipe,
  );
}

export function on_check(msg) {
  return on(
    "change",
    (event) => {
      let $ = checked(event);
      if ($.isOk()) {
        let val = $[0];
        return new Some(msg(val));
      } else if (!$.isOk()) {
        return new None();
      } else {
        throw makeError(
          "case_no_match",
          "lustre/event",
          125,
          "",
          "No case clause matched",
          { values: [$] }
        )
      }
    },
  );
}

export function mouse_position(event) {
  return $result.then$(
    $dynamic.field("clientX", $dynamic.float)(event),
    (x) => {
      return $result.then$(
        $dynamic.field("clientY", $dynamic.float)(event),
        (y) => { return new Ok([x, y]); },
      );
    },
  );
}
